import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { FormRenderer } from "@/react/components/FormRenderer";
import { ModalManagerProvider } from "@circle-react/components/Layout/ModalManagerProvider";
import { ThemeProvider } from "@circle-react/providers/Theme/ThemeProvider";
import "@circle-react-shared/uikit/TipTap/styles.scss";
import { ToastProvider } from "@circle-react-uikit/ToastV2";

const provider = new QueryClient();

interface FormsAppProps {
  id: number;
  index: number;
}

export const FormsApp = ({ id, index }: FormsAppProps) => (
  <QueryClientProvider client={provider}>
    <Router>
      <ThemeProvider>
        <ToastProvider>
          <ModalManagerProvider>
            <FormRenderer id={id} index={index} />
          </ModalManagerProvider>
        </ToastProvider>
      </ThemeProvider>
    </Router>
  </QueryClientProvider>
);
